import React, { useEffect,useMemo, useState } from 'react';
import NRICInput from '../../components/ui/forms/NRICInput';
import NRICWrap from '../../components/ui/forms/NRICWrap';
import FormTextWrap from '../../components/ui/forms/FormTextWrap';
import Label from '../../components/ui/forms/Label';
import Button from '../ui/Button';
import OTPForm from '../../components/ui/forms/OTPForm';
import TestModeWrapper from '../../components/ui/forms/TestModeWrapper';

const OTP = (props) => {
    const inputRefs = useMemo(() => Array(6).fill(0).map(i=> React.createRef()), []);
    const [currenttime, setCurrentTime] = useState(new Date());

    const {otpSettings, otpGeneratedTime} = props;
    
    const [otpDuration, setOTPDuration] = useState(120);
    const [otpGenerateEnabled, setOTPGenerateEnabled] = useState(false);
    const [otpGenerateEnabledCSS, setOTPGenerateEnabledCSS] = useState("otp_new_disabled");
    const [otpReGenerateText, setOTPReGenerateText] = useState("");

    useEffect(()=>
    {
        if(otpSettings!=undefined && otpSettings.length>0)
        {
            setOTPDuration(parseInt(otpSettings[0].value));
        }

        setInterval(()=>{
            setCurrentTime(new Date());
        },1000);
    },[]);

    const pad2 = (number)=> {
        return (number < 10 ? '0' : '') + number
    }

    const onRegenerateOTP = () =>
    {
        if(otpGenerateEnabled)
        {
            props.onResendOTP();
        } 
    }
    
    useEffect(()=>
    {
        if(currenttime!==undefined && otpGeneratedTime!=undefined)
        {
            let otpGenEnabledTime = new Date(otpGeneratedTime.valueOf());
            otpGenEnabledTime.setSeconds(otpGenEnabledTime.getSeconds() + otpDuration);

            if(currenttime>=otpGenEnabledTime)
            {
                setOTPGenerateEnabled(true);
                setOTPGenerateEnabledCSS("otp_new");
                setOTPReGenerateText("Request New OTP")
            }
            else
            {
                const diffTime = (otpGenEnabledTime-currenttime);
                let t = new Date(1970, 0, 1);
                t.setSeconds(diffTime/1000);

                const mm = pad2(t.getMinutes());
                const ss = pad2(t.getSeconds());

                setOTPReGenerateText(`Request New OTP ${mm}:${ss}`)
                setOTPGenerateEnabled(false);
                setOTPGenerateEnabledCSS("otp_new_disabled");
            }

        }
    },[currenttime]);

    const handleChange = (e,index) => {
        props.onChange(e);
        const name = e.target.name,
            val = e.target.value;
            
            if (name === 'otp2') {
                if ((val.length === 1)) {
                    inputRefs[index].current.focus();
                }
            }
            if (name === 'otp3') {
                if ((val.length === 1)) {
                    inputRefs[index].current.focus();
                }
            }
            if (name === 'otp4') {
                if ((val.length === 1)) {
                    inputRefs[index].current.focus();
                }
            }
            if (name === 'otp5') {
                if ((val.length === 1)) {
                    inputRefs[index].current.focus();
                }
            }
    }

    useEffect(() => 
    {
        if ((inputRefs[0].current.value.length === 1)) {
            inputRefs[1].current.focus();
         }
    },[props.state.otp1]);

    const onFocusOTP = (e,ref,name) => {
        if ((props.state.otp2 === "") && (props.state.otp1 === "") 
            && (name === 'otp2')) {
            ref.current.focus();
        }
        if ((props.state.otp3 === "") && (props.state.otp1 === "") && (props.state.otp2 === "")
            && (name === 'otp3')) {
            ref.current.focus();
        }
        if ((props.state.otp4 === "") && (props.state.otp3 === "") && (props.state.otp2 === "")
            && (name === 'otp4')) {
            ref.current.focus();
        }
        if ((props.state.otp5 === "") && (props.state.otp4 === "") && (props.state.otp3 === "") && (props.state.otp2 === "") && (props.state.otp1 === "")
            && (name === 'otp5')) {
            ref.current.focus();
        }
        if ((props.state.otp6 === "") && (props.state.otp5 === "") && (props.state.otp4 === "") && (props.state.otp3 === "") && (props.state.otp2 === "") && (props.state.otp1 === "")
            && (name === 'otp6')) {
            ref.current.focus();
        }
    }



    const onKeyOTP = (e,index,name) => {
        let key = e.keyCode || e.charCode;

        if ((key === 8 || key === 46) && (props.state.otp2 === '') && name === 'otp2') {
            inputRefs[index].current.focus();
        }

        if ((key === 8 || key === 46) && (props.state.otp3 === '') && name === 'otp3') {
            inputRefs[index].current.focus();
        }

        if ((key === 8 || key === 46) && (props.state.otp4 === '') && name === 'otp4') {
            inputRefs[index].current.focus();
        }

        if ((key === 8 || key === 46) && (props.state.otp5 === '') && name === 'otp5') {
            inputRefs[index].current.focus();
        }

        if ((key === 8 || key === 46) && (props.state.otp6 === '') && name === 'otp6') {
            inputRefs[index].current.focus();
        }
    }
    

    
        const 
        {   
            state,
            errorValidateOTP,
            errorGenerateOTP,
            otpText
        } = props;
        return (
            <>
                <div data-test-id = 'otp'>
                    <FormTextWrap>
                        Please enter the OTP code sent to you.
                    </FormTextWrap>
                    <OTPForm>
                        <NRICWrap className="otp_wrap">
                        {new Array(6).fill(0).map((inp, index)=>(
                            <NRICInput
                                key = {index}
                                className="input_otp"
                                ref = {inputRefs[index]}
                                onChange={(e) => handleChange(e,(index + 1))}
                                onKeyDown={(e) => onKeyOTP(e,(index-1),'otp'+ (index + 1))}
                                onFocus={(e) =>onFocusOTP(e,inputRefs[index],'otp'+ (index + 1))}
                                type="tel"
                                maxlength="1"
                                value={state['otp'+ (index + 1)]}
                                name={'otp'+ (index + 1)}
                            />
                            ))
                        }
                            
                        </NRICWrap>
                        <div className={otpGenerateEnabledCSS} onClick={() => onRegenerateOTP()}>
                            {otpReGenerateText}
                    </div>
                    </OTPForm>
                    {
                        state.otp1 && state.otp2 && state.otp3 && state.otp4 && state.otp5 && state.otp6 ?
                            <Button onClick={() => props.onVerifyOTP()}>
                                Submit
                        </Button> :
                        <Button disabled>
                                Submit
                        </Button>
                    }
                    {
                        errorValidateOTP !== '' &&
                        <Label isError name="errorValidateOTP">
                            {errorValidateOTP}
                        </Label>
                    }
                    {errorGenerateOTP !== '' &&
                        <Label isError name="errorGenerateOTP">
                            {errorGenerateOTP}
                        </Label>
                    }
                    {otpText !== '' &&
                        <TestModeWrapper>
                            {otpText}
                        </TestModeWrapper>
                    }
                </div>
            </>
        );
    };

export default OTP;
